/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Public_Site_Not_Found_TitleInputs */

const cs_public_site_not_found_title = /** @type {(inputs: Public_Site_Not_Found_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Web nenalezen`)
};

const en_public_site_not_found_title = /** @type {(inputs: Public_Site_Not_Found_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Website not found`)
};

/**
* | output |
* | --- |
* | "Website not found" |
*
* @param {Public_Site_Not_Found_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const public_site_not_found_title = /** @type {((inputs?: Public_Site_Not_Found_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Public_Site_Not_Found_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_public_site_not_found_title(inputs)
	return cs_public_site_not_found_title(inputs)
});